import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { ApiDataProps } from "../Tenants";
import { TypePageActions } from "../Plans";
import { AddBtn } from "@/App/DiscountTypes/Add";
import { TableData } from "@/App/DiscountTypes/Table";
import {
  getDiscountTypesData,
  searchDiscountTypesData,
} from "@/Api/discountTypes";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";

export type TableDataProps = {
  id: number;
  uuid: string;
  name: string;
  is_active: boolean;
  tenant_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  tenant: {
    id: number;
    name: string;
  };
};

export const PageList = () => {
  const [listData, setListData] = useState({} as ApiDataProps<TableDataProps>);
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();
  useEffect(() => {
    (async () => {
      const { data } = await getDiscountTypesData();
      setListData(data?.response);
      setState("production");
    })();
  }, []);

  const pageActions: TypePageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        setState("loading");

        const { data } = await getDiscountTypesData(listData?.current_page + 1);
        setListData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        setState("loading");

        const { data } = await getDiscountTypesData(listData?.current_page - 1);
        setListData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        setState("loading");

        const { data } = await getDiscountTypesData(listData?.last_page);
        setListData(data?.response);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-discount-types-list")}>
        <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
          <h2 className="text-2xl font-semibold flex gap-2 items-center">
            Tipos de descontos
          </h2>
          <If condition={hasPermission("create-discount-type")}>
            <AddBtn updateFront={setListData} />
          </If>
        </div>
        <div className="flex flex-col gap-3">
          <SearchComponent
            updateFront={setListData}
            setState={setState}
            funcSearch={searchDiscountTypesData}
            placeholder="Pesquisar"
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={4} lines={6} />
          ) : (
            <TableData
              dataApi={listData}
              pageActions={pageActions}
              updateFront={setListData}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
